import Appendix from "../pages/appendix";
import ErrorCodesPage from "../pages/error_codes";
import CancelRemittance from "../pages/cancel_remittance";
import GetToken from "../pages/get_Token";
import GetAgents from "../pages/get_agents";
import GetCountries from "../pages/get_countries";
import GetEntities from "../pages/get_entities";
import GetCountryServices from "../pages/get_country_services";
import GetBanksByCountry from "../pages/get_banks_by_country";
import GetExchangeRates from "../pages/get_exchange_rates";
import GetBalance from "../pages/get_balance";
import Home from "../pages/home";
import SendRemittance from "../pages/send_remittance";
import GetTransactionDetails from "../pages/transaction_details";
import ValidateAccount from "../pages/validate_account";
import UpdateBeneficiaryDetails from "../pages/update_beneficiary_details";
import DahabCredentialsList from "../pages/settings/dahab_credentials/index";
import { PATH_PRIVATE, PATH_SETTINGS } from "./paths";
import { Element } from "./types";
import Settings from "../pages/settings";
import WhitelistIPs from "../pages/settings/WhitelistIP/WhitelistIPs";

export const elements: Element[] = [
  {
    Name: "Get Started",
    Path: PATH_PRIVATE.Home,
    Component: <Home />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
      >
        <path d="M19.9794922,7.9521484l-6-5.2666016c-1.1339111-0.9902344-2.8250732-0.9902344-3.9589844,0l-6,5.2666016C3.3717041,8.5219116,2.9998169,9.3435669,3,10.2069702V19c0.0018311,1.6561279,1.3438721,2.9981689,3,3h2.5h7c0.0001831,0,0.0003662,0,0.0006104,0H18c1.6561279-0.0018311,2.9981689-1.3438721,3-3v-8.7930298C21.0001831,9.3435669,20.6282959,8.5219116,19.9794922,7.9521484z M15,21H9v-6c0.0014038-1.1040039,0.8959961-1.9985962,2-2h2c1.1040039,0.0014038,1.9985962,0.8959961,2,2V21z M20,19c-0.0014038,1.1040039-0.8959961,1.9985962-2,2h-2v-6c-0.0018311-1.6561279-1.3438721-2.9981689-3-3h-2c-1.6561279,0.0018311-2.9981689,1.3438721-3,3v6H6c-1.1040039-0.0014038-1.9985962-0.8959961-2-2v-8.7930298C3.9997559,9.6313477,4.2478027,9.0836182,4.6806641,8.7041016l6-5.2666016C11.0455933,3.1174927,11.5146484,2.9414673,12,2.9423828c0.4853516-0.0009155,0.9544067,0.1751099,1.3193359,0.4951172l6,5.2665405C19.7521973,9.0835571,20.0002441,9.6313477,20,10.2069702V19z" />
      </svg>
    ),
  },
  {
    Name: "Get Token",
    Path: PATH_PRIVATE.GetToken,
    Component: <GetToken />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
      >
        <title>lock</title>
        <path d="M16,8C17.66,8 19,9.34 19,11V19C19,20.66 17.66,22 16,22H7C5.34,22 4,20.66 4,19V11C4,9.34 5.34,8 7,8V6.5C7,4 9,2 11.5,2C14,2 16,4 16,6.5V8M7,9C5.9,9 5,9.9 5,11V19C5,20.1 5.9,21 7,21H16C17.1,21 18,20.1 18,19V11C18,9.9 17.1,9 16,9H7M15,8V6.5C15,4.57 13.43,3 11.5,3C9.57,3 8,4.57 8,6.5V8H15M11.5,14C10.67,14 10,14.67 10,15.5C10,16.33 10.67,17 11.5,17C12.33,17 13,16.33 13,15.5C13,14.67 12.33,14 11.5,14M11.5,13C12.88,13 14,14.12 14,15.5C14,16.88 12.88,18 11.5,18C10.12,18 9,16.88 9,15.5C9,14.12 10.12,13 11.5,13Z" />
      </svg>
    ),
  },
  {
    Name: "Get Agents",
    Path: PATH_PRIVATE.GetAgents,
    Component: <GetAgents />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon" viewBox="0 0 24 24"><title>map-marker</title><path d="M11.5,7C12.88,7 14,8.12 14,9.5C14,10.88 12.88,12 11.5,12C10.12,12 9,10.88 9,9.5C9,8.12 10.12,7 11.5,7M11.5,8C10.67,8 10,8.67 10,9.5C10,10.33 10.67,11 11.5,11C12.33,11 13,10.33 13,9.5C13,8.67 12.33,8 11.5,8M6.8,12.36L11.5,20.09L16.2,12.36V12.36C16.71,11.5 17,10.55 17,9.5C17,6.46 14.54,4 11.5,4C8.46,4 6,6.46 6,9.5C6,10.55 6.29,11.5 6.8,12.36V12.36M17.05,12.88L11.5,22L5.95,12.88V12.88C5.35,11.89 5,10.74 5,9.5C5,5.91 7.91,3 11.5,3C15.09,3 18,5.91 18,9.5C18,10.74 17.65,11.89 17.05,12.88V12.88Z" /></svg>
    ),
  },
  {
    Name: "Validate Account",
    Path: PATH_PRIVATE.ValidateAccount,
    Component: <ValidateAccount />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"
      ><title>account</title><path d="M11.5,14C15.64,14 19,15.57 19,17.5V20H4V17.5C4,15.57 7.36,14 11.5,14M18,17.5C18,16.12 15.09,15 11.5,15C7.91,15 5,16.12 5,17.5V19H18V17.5M11.5,5C13.43,5 15,6.57 15,8.5C15,10.43 13.43,12 11.5,12C9.57,12 8,10.43 8,8.5C8,6.57 9.57,5 11.5,5M11.5,6C10.12,6 9,7.12 9,8.5C9,9.88 10.12,11 11.5,11C12.88,11 14,9.88 14,8.5C14,7.12 12.88,6 11.5,6Z" />
      </svg>
    ),
  },
  {
    Name: "Get Countries",
    Path: PATH_PRIVATE.GetCountries,
    Component: <GetCountries />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24">
        <title>flag</title><path d="M5,5H13.42L14.58,7H19V16H13L11.85,14H6V21H5V5M18,15V8H14L12.85,6H6V13H12.42L13.58,15H18Z" /></svg>
    ),
  },
  {
    Name: "Get Entities",
    Path: PATH_PRIVATE.GetEntities,
    Component: <GetEntities />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>grid</title><path d="M5,3H18C19.66,3 21,4.34 21,6V19C21,20.66 19.66,22 18,22H5C3.34,22 2,20.66 2,19V6C2,4.34 3.34,3 5,3M5,4C3.9,4 3,4.9 3,6V9H8V4H5M3,19C3,20.1 3.9,21 5,21H8V16H3V19M8,10H3V15H8V10M18,21C19.1,21 20,20.1 20,19V16H15V21H18M20,10H15V15H20V10M20,6C20,4.9 19.1,4 18,4H15V9H20V6M9,4V9H14V4H9M9,21H14V16H9V21M14,10H9V15H14V10Z" /></svg>
    ),
  },
  {
    Name: "Get Country Services",
    Path: PATH_PRIVATE.GetCountryServices,
    Component: <GetCountryServices />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>view-module</title><path d="M15,6H20V12H15V6M9,12V6H14V12H9M15,19V13H20V19H15M9,19V13H14V19H9M3,19V13H8V19H3M3,12V6H8V12H3M4,7V11H7V7H4M10,7V11H13V7H10M16,7V11H19V7H16M4,14V18H7V14H4M10,14V18H13V14H10M16,14V18H19V14H16Z" /></svg>
    ),
  },
  {
    Name: "Get Banks By Country",
    Path: PATH_PRIVATE.GetBanksByCountry,
    Component: <GetBanksByCountry />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>bank</title><path d="M11,2.5L20,7V9H2V7L11,2.5M15,10H19V18H15V10M2,22V19H20V22H2M9,10H13V18H9V10M3,10H7V18H3V10M3,20V21H19V20H3M4,11V17H6V11H4M10,11V17H12V11H10M16,11V17H18V11H16M3,8H19V7.6L11,3.58L3,7.6V8Z" /></svg>
    ),
  },
  {
    Name: "Get Exchange Rates",
    Path: PATH_PRIVATE.GetExchangeRates,
    Component: <GetExchangeRates />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>swap-horizontal</title><path d="M21,9L17,5V8H10V10H17V13M7,11L3,15L7,19V16H14V14H7V11Z" /></svg>
    ),
  },{
    Name: "Send Remittance",
    Path: PATH_PRIVATE.SendRemittance,
    Component: <SendRemittance />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        enable-background="new 0 0 24 24"
        viewBox="0 0 24 24"
      >
        <title>credit-card</title>
        <path d="M5,5H18C19.66,5 21,6.34 21,8V17C21,18.66 19.66,20 18,20H5C3.34,20 2,18.66 2,17V8C2,6.34 3.34,5 5,5M5,6C3.9,6 3,6.9 3,8V9H20V8C20,6.9 19.1,6 18,6H5M3,17C3,18.1 3.9,19 5,19H18C19.1,19 20,18.1 20,17V12H3V17M5,16H9V17H5V16M11,16H14V17H11V16M3,10V11H20V10H3Z" />
      </svg>
    ),
  },
  {
    Name: "Cancel Remittance",
    Path: PATH_PRIVATE.CancelRemittance,
    Component: <CancelRemittance />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        viewBox="0 0 24 24"
        className="side-menu__icon"
      >
        <title>cancel</title>
        <path d="M11.5,22C6.26,22 2,17.75 2,12.5C2,7.25 6.25,3 11.5,3C16.75,3 21,7.25 21,12.5C21,17.75 16.75,22 11.5,22M11.5,21C16.2,21 20,17.19 20,12.5C20,10.33 19.19,8.35 17.86,6.85L5.85,18.85C7.36,20.19 9.33,21 11.5,21M11.5,4C6.81,4 3,7.81 3,12.5C3,14.67 3.81,16.64 5.15,18.14L17.15,6.14C15.65,4.81 13.67,4 11.5,4Z" />
      </svg>
    ),
  },
  {
    Name: "Get Transaction",
    Path: PATH_PRIVATE.GetTransactionDetails,
    Component: <GetTransactionDetails />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"
      >
        <title>clipboard-check</title>
        <path d="M6,5H8.5C8.5,3.34 9.84,2 11.5,2C13.16,2 14.5,3.34 14.5,5H17C18.66,5 20,6.34 20,8V19C20,20.66 18.66,22 17,22H6C4.34,22 3,20.66 3,19V8C3,6.34 4.34,5 6,5M6,6C4.9,6 4,6.9 4,8V19C4,20.1 4.9,21 6,21H17C18.1,21 19,20.1 19,19V8C19,6.9 18.1,6 17,6H16V9H7V6H6M8,8H15V6H8V8M11.5,3C10.4,3 9.5,3.9 9.5,5H13.5C13.5,3.9 12.6,3 11.5,3M17.15,11.6L10,18.75L6.8,15.55L7.5,14.84L10,17.34L16.44,10.89L17.15,11.6Z" />
      </svg>
    ),
  },
  {
    Name: "Update Beneficiary Details",
    Path: PATH_PRIVATE.UpdateBeneficiaryDetails,
    Component: <UpdateBeneficiaryDetails />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>pencil</title><path d="M19.71,8.04L17.37,10.37L13.62,6.62L15.96,4.29C16.35,3.9 17,3.9 17.37,4.29L19.71,6.63C20.1,7 20.1,7.65 19.71,8.04M3,17.25L13.06,7.18L16.81,10.93L6.75,21H3V17.25M16.62,5.04L15.08,6.58L17.42,8.92L18.96,7.38L16.62,5.04M15.36,11L13,8.64L4,17.66V20H6.34L15.36,11Z" /></svg>
    ),
  },
  {
    Name: "Get Balance",
    Path: PATH_PRIVATE.GetBalance,
    Component: <GetBalance />,
    Icon: (
     <svg xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon" viewBox="0 0 24 24"><title>currency-usd</title><path d="M11,4H12V6C15.29,6.15 16,7.7 16,9H15C15,7.67 13.82,7 11.5,7C10.68,7 8,7.16 8,9.25C8,10.12 8,11.11 11.62,12L13.23,12.5C15.76,13.43 16,14.57 16,15.75C16,17.63 14.5,18.84 12,19V21H11V19C7.71,18.85 7,17.3 7,16H8C8,17.33 9.18,18 11.5,18C12.32,18 15,17.84 15,15.75C15,14.88 15,13.89 11.38,13L9.77,12.5C7.24,11.57 7,10.43 7,9.25C7,7.37 8.5,6.16 11,6V4Z" /></svg>
    ),
  },
  {
    Name: "Settings",
    Path: PATH_SETTINGS.Root,
    Component: <Settings />,
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 24 24"><path d="M12 2L2 7v6c0 5 3 9 10 9s10-4 10-9V7l-10-5zM12 12a3 3 0 100-6 3 3 0 000 6z" /></svg>
    ),
    HideInSidebar: true,
  },
  {
    Name: "API Credentials",
    Path: PATH_SETTINGS.DahabCredentials,
    Component: <DahabCredentialsList />,
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 24 24"><path d="M12 2L2 7v6c0 5 3 9 10 9s10-4 10-9V7l-10-5zM12 12a3 3 0 100-6 3 3 0 000 6z" /></svg>
    ),
    HideInSidebar: true,
  },
  {
    Name: "Whitelist IPs",
    Path: PATH_SETTINGS.WhitelistIPs,
    Component: <WhitelistIPs />,
    Icon: (
      <svg xmlns="http://www.w3.org/2000/svg" className="side-menu__icon" viewBox="0 0 24 24"><path d="M12 2L2 7v6c0 5 3 9 10 9s10-4 10-9V7l-10-5zM12 12a3 3 0 100-6 3 3 0 000 6z" /></svg>
    ),
    HideInSidebar: true,
  },
  {
    Name: "Error Codes",
    Path: PATH_PRIVATE.ErrorCodes,
    Component: <ErrorCodesPage />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"><title>alert-circle-outline</title><path d="M11,15H13V17H11V15M11,7H13V13H11V7M12,2C6.47,2 2,6.5 2,12A10,10 0 0,0 12,22A10,10 0 0,0 22,12A10,10 0 0,0 12,2M12,20A8,8 0 0,1 4,12A8,8 0 0,1 12,4A8,8 0 0,1 20,12A8,8 0 0,1 12,20Z" /></svg>
    ),
  },
  {
    Name: "Appendix",
    Path: PATH_PRIVATE.Appendix,
    Component: <Appendix />,
    Icon: (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        className="side-menu__icon"
        viewBox="0 0 24 24"
      >
        <title>clipboard-text</title>
        <path d="M6,5H8.5C8.5,3.34 9.84,2 11.5,2C13.16,2 14.5,3.34 14.5,5H17C18.66,5 20,6.34 20,8V19C20,20.66 18.66,22 17,22H6C4.34,22 3,20.66 3,19V8C3,6.34 4.34,5 6,5M6,6C4.9,6 4,6.9 4,8V19C4,20.1 4.9,21 6,21H17C18.1,21 19,20.1 19,19V8C19,6.9 18.1,6 17,6H16V9H7V6H6M8,8H15V6H8V8M11.5,3C10.4,3 9.5,3.9 9.5,5H13.5C13.5,3.9 12.6,3 11.5,3M6,11H17V12H6V11M6,14H17V15H6V14M6,17H15V18H6V17Z" />
      </svg>
    ),
  },
];
